<template>
  <label class="toggle" for="myToggle">
    <input @change="emitChange($event)" class="toggle__input" name="" type="checkbox" id="myToggle">
    <div class="toggle__fill"></div>
  </label>
</template>

<script>
export default {
  name: 'Toggler',
  methods: {
    emitChange($event) {
      this.$emit('change', $event.target.checked)
    }
  }
}
</script>

<style scoped>


</style>